import { Navigate, Route } from "react-router-dom";

import { List as ListColors } from "../../Colors/components";
import { List as ListRoles, NewRole, EditRole } from "../../Roles/components";
import { List as ListUsers, NewUSer } from "../../Users/components";

import manufactureRoutes from "../../Manufacture/routes";
import productCategoryRoutes from "../../ProductCategory/routes";

const adminRoutes = [
    <Route index element={<Navigate to="general" replace />} key={"admin:index"} />,
    <Route path="general" element={<ListColors />} key={"list"} />,
    <Route path="manufacture" key={"manufacture"}>
        {manufactureRoutes}
    </Route>,
    <Route path="product-category" key={"product-category"}>
        {productCategoryRoutes}
    </Route>,
    <Route path="suppliers" element={<div>test</div>} key={"list:details"} />,
    <Route path="roles" element={<ListRoles />} key={"roles:list"} />,
    <Route path="roles/new" element={<NewRole />} key={"roles:new"} />,
    <Route path="roles/edit/:id" element={<EditRole />} key={"roles:edit"} />,
    <Route path="users" element={<ListUsers />} key={"users:list"} />,
    <Route path="users/new" element={<NewUSer />} key={"users:new"} />,
];

export default adminRoutes;
